/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-add-to-cart">
    <button class="btn btn-primary btn-add-to-cart" @click="addToCart">{{ buttonText }}</button>
  </div>
</template>

<script>
export default {
  name: 'AddToCart',
  props: {
    sku: {
      type: String,
      required: true
    },
    qty: {
      type: Number,
      default: () => 1
    },
    enableAdd: {
      type: Boolean,
      default: true
    },
    variant: {
      type: Object,
      default: null
    },
    buttonText: {
      type: String,
      default: function () {
        return this.$t('add-to-cart')
      }
    }
  },
  methods: {
    addToCart ($event) {
      if (!this.enableAdd) {
        return this.$emit('cannotAdd', true)
      }
      const _this = this
      this.$emit('loading', true)
      return this.$store.dispatch('cart/update', { sku: this.sku, qty: this.qty, append: true, variant: this.variant })
        .then(() => {
          _this.$emit('success')
          _this.$emit('loading', false)
        })
        .catch(() => {
          _this.$emit('loading', false)
        })
    }
  }
}
</script>
